import {PATH_NAMES} from "../constants/constants";
import {retrieveProperty} from "../services/property.service";
import {retrieveBuildingAreaById} from "../services/buildingAreas.service";
import {retrieveWidgetSettings, retrieveWidgetSettingsWithCompany} from "../services/settings.service"
import {WidgetCredentials} from "../models/WidgetSettings";
import {COMPANY_LINKS, CompanyLink} from "../constants/companyLinks";

// const regexp = "(handiscover.com)|(localhost:3000)|(localhost:80)|(localhost)({ADD_YOUR_OWN_IP_ADDRESS_FOR_MOBILE_TEST})$"
const regexp = "(handiscover.com)|(localhost:3000)|(localhost:80)|(localhost)$";

export const getAreaId = (widgetCredentials: WidgetCredentials) => {

  const {pathname, host} = document.location;
  let buildingAreaId, propertyId;

  if (Boolean(host.match(regexp)) && (pathname.includes(PATH_NAMES.BUILDING_AREA_DEMO) || pathname.includes(PATH_NAMES.BUILDING_AREA_PAGE)) ) {
    buildingAreaId = pathname.split("/")[3]
  } else {
    buildingAreaId = widgetCredentials.buildingAreaID;
  }
  
  if (Boolean(host.match(regexp)) && (pathname.includes(PATH_NAMES.PROPERTY_DEMO) || pathname.includes(PATH_NAMES.PROPERTY_PAGE))) {
    propertyId = pathname.split("/")[3]
  } else {
    propertyId = widgetCredentials.propertyID;
  }

  return {
    buildingAreaId,
    propertyId
  }
}

export const isURLPage = () => {
  const {pathname, host} = document.location;
  if (Boolean(host.match(regexp)) && pathname.includes(PATH_NAMES.BUILDING_AREA_PAGE)) {
    return true;
  } else if (Boolean(host.match(regexp)) && pathname.includes(PATH_NAMES.PROPERTY_PAGE)) {
    return true;
  }
  return getCompanyLink() !== undefined;
}

export const isURLDemo = () => {
  const {pathname, host} = document.location;
  if (Boolean(host.match(regexp)) && pathname.includes(PATH_NAMES.BUILDING_AREA_DEMO)) {
    return true;
  } else if (Boolean(host.match(regexp)) && pathname.includes(PATH_NAMES.PROPERTY_DEMO)) {
    return true;
  } else {
    return false;
  }
}

export const fetchWidgetSettings = async (buildingAreaId: string | null, propertyId: string | null) => {
  /* If it's a demo/page link we need to first fetch the property or building area to be able to receive the company id
    because if we fetch retrieveWidgetSettings() without argument like we do below if it isn't not a demo/page it will fetch
    settings from company related to the companyIdAPIKey which is Handiscover API key in demo/page, and this works if client has embedded script.
  */

  if (isURLDemo() || isURLPage()) {
    let facility;
    if (buildingAreaId) {
      facility = await retrieveBuildingAreaById(buildingAreaId);
    } else if (propertyId) {
      facility = await retrieveProperty(propertyId);
    }
    if (facility) {
      const settings = await retrieveWidgetSettingsWithCompany(facility.company);
      if (settings.results.length !== 0) {
        return [settings.results[0]]
      } else {
        return undefined;
      }
    }
  } else {
    const settings = await retrieveWidgetSettings();
    if (settings.results.length !== 0) {
      return [settings.results[0]];
    } else {
      return undefined;
    }
  }
}

export const getCompanyName = (): string | undefined => {
  const {pathname} = document.location;
  return pathname.split('/')[1]?.toLowerCase();
}

// the direct link client of the current page, see COMPANY_LINKS
export const getCompanyLink = (): CompanyLink | undefined => {
  const companyName = getCompanyName();
  return companyName && Object.prototype.hasOwnProperty.call(COMPANY_LINKS, companyName)
    ? COMPANY_LINKS[companyName]
    : undefined;
}

export const getAttributeValueFromCurrentURL = (attributeName: string): string | null => {
  const searchParams = new URL(window.location.href).searchParams;
  return searchParams.get(attributeName);
}

export const appendUtmParams = (url: string | undefined): string | undefined => {
  if (!url) return undefined;

  const utmParams: Record<string, string> = {
    utm_source: 'haccess_widget',
    utm_medium: 'referral',
    utm_campaign: 'book_now_button',
  };

  try {
    const parsed = new URL(url);
    Object.entries(utmParams).forEach(([key, value]) => {
      if (!parsed.searchParams.has(key)) {
        parsed.searchParams.set(key, value);
      }
    });
    return parsed.toString();
  } catch {
    return url;
  }
};
